"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _websocketNats = _interopRequireDefault(require("websocket-nats"));

var _default = function _default(token) {
  var destination = window.location.host;
  var protocol = 'wss';

  if (window.REALTIME_MESSAGING_WEBSOCKET_PROTOCOL) {
    protocol = window.REALTIME_MESSAGING_WEBSOCKET_PROTOCOL;
  }

  return _websocketNats.default.connect({
    url: "".concat(protocol, "://").concat(destination, "/api/nats/").concat(token, "/pubsub"),
    json: true
  });
};

exports.default = _default;